import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    available: true,
    loading: false,
    context: { canManage: false, unreadCount: 0, kinds: [], modules: [] },
    inbox: [],
    history: [],
    historyTotal: 0
  },
  getters: {
    canManage: (state) => state.context.canManage,
    unreadCount: (state) => state.context.unreadCount
  },
  mutations: {
    SET_AVAILABLE(state, value) {
      state.available = value;
    },
    SET_LOADING(state, value) {
      state.loading = value;
    },
    SET_CONTEXT(state, value) {
      state.context = { ...state.context, ...value };
    },
    SET_INBOX(state, value) {
      state.inbox = value || [];
    },
    SET_HISTORY(state, payload) {
      state.history = payload.items || [];
      state.historyTotal = payload.total || 0;
    },
    MARK_READ(state, payload) {
      state.inbox = state.inbox.filter((item) => !(item.id === payload.id && item.revision === payload.revision));
      state.history = state.history.map((item) =>
        item.id === payload.id && item.revision === payload.revision ? { ...item, isRead: true } : item
      );
      state.context.unreadCount = Math.max(0, state.context.unreadCount - 1);
    }
  },
  actions: {
    async initialize({ dispatch, commit }, options = {}) {
      try {
        commit('SET_AVAILABLE', true);
        await dispatch('loadContext');
        await dispatch('loadInbox', options);
      } catch (error) {
        console.warn('[Release Notes] Recurso temporariamente indisponível.', error);
        commit('SET_AVAILABLE', false);
        commit('SET_INBOX', []);
      }
    },
    async loadContext({ commit }) {
      const response = await Vue.prototype.$http2.get('/api/release-notes/context');
      commit('SET_CONTEXT', response.data.data || {});
      return response.data.data;
    },
    async loadInbox({ commit, rootState }, options = {}) {
      const locale = options.locale || rootState?.auth?.userInfo?.language || Vue.prototype.$i18n?.locale || 'pt-BR';
      const response = await Vue.prototype.$http2.get('/api/release-notes', {
        params: { view: 'inbox', locale, pageSize: 50 }
      });
      commit('SET_INBOX', response.data.data?.items || []);
      return response.data.data;
    },
    async loadHistory({ commit }, params = {}) {
      commit('SET_LOADING', true);
      try {
        const response = await Vue.prototype.$http2.get('/api/release-notes', {
          params: { view: 'history', locale: params.locale || 'pt-BR', pageSize: 50, cursor: params.cursor }
        });
        commit('SET_HISTORY', response.data.data || { items: [], total: 0 });
        return response.data.data;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async getById(_, { id, locale }) {
      const response = await Vue.prototype.$http2.get(`/api/release-notes/${id}`, { params: { locale } });
      return response.data.data;
    },
    async markRead({ commit }, note) {
      await Vue.prototype.$http2.put(`/api/release-notes/${note.id}/read`, { revision: note.revision });
      commit('MARK_READ', { id: note.id, revision: note.revision });
    }
  }
};
